import { ArrayValue, isArray, Schema } from '@coveo/bueno';
import { configuration } from '../../../app/common-reducers.js';
import { updatePage } from '../../../features/pagination/pagination-actions.js';
import { buildCriterionExpression, criterionDefinition, } from '../../../features/sort-criteria/criteria.js';
import { registerSortCriterion, updateSortCriterion, } from '../../../features/sort-criteria/sort-criteria-actions.js';
import { sortCriteriaReducer as sortCriteria } from '../../../features/sort-criteria/sort-criteria-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { validateInitialState } from '../../../utils/validate-payload.js';
import { buildController, } from '../../controller/headless-controller.js';
function validateSortInitialState(engine, state) {
    if (!state) {
        return;
    }
    const schema = new Schema({
        criterion: new ArrayValue({ each: criterionDefinition }),
    });
    const criterion = getCriterionAsArray(state);
    const initialState = { ...state, criterion };
    validateInitialState(engine, schema, initialState, 'buildSort');
}
function getCriterionAsArray(state) {
    if (!state.criterion) {
        return [];
    }
    return isArray(state.criterion) ? state.criterion : [state.criterion];
}
/**
 * Creates a `Sort` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `Sort` controller properties.
 * @returns A `Sort` controller instance.
 */
export function buildCoreSort(engine, props) {
    if (!loadSortReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    validateSortInitialState(engine, props.initialState);
    const criterion = props.initialState?.criterion;
    if (criterion) {
        dispatch(registerSortCriterion(criterion));
    }
    return {
        ...controller,
        sortBy(criterion) {
            dispatch(updateSortCriterion(criterion));
            dispatch(updatePage(1));
        },
        isSortedBy(criterion) {
            return this.state.sortCriteria === buildCriterionExpression(criterion);
        },
        get state() {
            return {
                sortCriteria: getState().sortCriteria,
            };
        },
    };
}
function loadSortReducers(engine) {
    engine.addReducers({ configuration, sortCriteria });
    return true;
}
